import tw, { styled } from 'twin.macro';
export type ModalTitleProps = {
  children: React.ReactNode | string;
};
export const AuthTitle = styled.h2(({ isModal = true }: { isModal?: boolean }) => [
  tw`font-semibold lg:text-3xl text-2xl  lg:leading-11.5 leading-9 text-black text-center`,
  !isModal && tw`lg:text-4xl text-left`,
]);
